// import CupraLogo from './cupraLogo/CupraLogo';
import AudiLogo from './AudiLogo';
import BentleyLogo from './BentleyLogo';
import CupraLogo from './CupraLogo';
import VolkswagenLogo from './VolkswagenLogo';
import { CLIENT_NAME } from '../../js/config/_global';

const LOGOS = {
    audi: AudiLogo,
    bentley: BentleyLogo,
    cupra: CupraLogo,
    volkswagen: VolkswagenLogo,
};

export default LOGOS[CLIENT_NAME];

